var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.972,
    height: 66.972,
    viewBox: "0 0 66.972 66.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M33.486,0A33.486,33.486,0,1,0,66.972,33.486,33.525,33.525,0,0,0,33.486,0ZM52.2,24.674,30.8,45.907a3.293,3.293,0,0,1-4.616.084L14.855,35.668a3.4,3.4,0,0,1-.252-4.7,3.32,3.32,0,0,1,4.7-.168l8.98,8.225L47.418,19.89A3.383,3.383,0,0,1,52.2,24.674Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.83484250a743dcb7fe6a8f934756697f.svg";
export { ForwardRef as ReactComponent };